<template>
  <div class="expired-main">
    <img src="@/assets/images/phelcom/eyercloud_logo.svg" alt="Logo EyerCloud" width="214">

    <div class="denied-box">
      <h2>{{ $t('denied.error') }}</h2>

      <h1>{{ $t('denied.deniedAccess') }}</h1>

      <p>{{ $t('denied.deniedAccessMessage') }}</p>

      <button class="btn btn-success" type="button" name="button" data-test="btnBackToBegin" @click="goBack()">{{ $t('denied.backToBegin') }}</button>
    </div>

    <div class="powered-box">
      <p class="d-inline-block">POWERED BY</p>
      <a href="https://phelcom.com/" class="logo d-inline-block" target="_blank" data-test="anchorPhelcomLink">
        <img src="@/assets/images/phelcom/phelcom_logo_horizontal_blue.svg" alt="">
      </a>
      <img class="aws-logo" src="@/assets/images/erjart/logo_aws.svg" alt="Logo AWS">
      <p class="d-inline-block">v {{ appVersion }}</p>
    </div>
  </div>
</template>

<style lang="scss">
  .expired-main {
    display:                            flex;
    flex-direction:                     column;
    justify-content:                    space-between;
    align-items:                        center;
    min-height:                         500px;
    width:                              100%;
    padding:                            2rem 0 1rem;
    background:                         unset !important;

    .denied-box {
      @include                          border_radius(10px);
      text-align:                       center;
      display:                          flex;
      flex-direction: column;
      align-items: center;
      gap:                              28px;
      max-width:                        470px;
      padding:                          1rem 0 2rem;

      h1 {
        font-size:                      38px;
        font-weight:                    500;
        line-height:                    normal;
      }

      h2 {
        font-size:                      26px;
        font-weight:                    300;
        line-height:                    normal;
      }

      p {
        font-size:                      var(--font-size-14);
        font-weight:                    400;
        line-height:                    140%; /* 19.6px */
      }

      h1,
      h2,
      p {
        color:                          var(--Brand-Primary);
        margin:                         0;
      }

      .btn.btn-success {
        color:                          var(--Shades-W, var(--W, #FFF));
        font-size:                      var(--font-size-14);
        font-weight:                    700;
        line-height:                    normal;
        letter-spacing:                 4.2px;
        text-transform:                 uppercase;
        width:                          100%;
        padding:                        20px;;
      }
    }
  }

  .powered-box {
    display:                            flex;
    flex-direction:                     row;
    align-items:                        center;
    gap:                                10px;

    p {
      color:                            var(--Brand-Primary, #1B294A);
      font-size:                        var(--font-size-8);
      font-weight:                      400;
      letter-spacing:                   1.52px;
      margin:                           0;
    }

    .logo {
      color:                            #1B294A;
      text-decoration:                  none;
      width:                            90px;
      // margin:                           0 10px;
      img {
        width:                          100%;
      }
    }
  }

  @media (max-width: 767px) {
    .denied-main {
      .denied-box {
        padding:                         15px;
      }
    }
  }
</style>

<script>
export default {
  name: 'denied',
  data: () => ({
    appVersion: process.env.VUE_APP_VERSION,
  }),
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<!-- TODO userStore.logout! -->
